import * as React from "react";
const WishlistContext = React.createContext();

function wishlistReducer(store = [], action) {
	switch (action.type) {
		case "ADDED_WISHLIST_PRODUCT":
			return action.data;
		default:
			throw new Error(`Unhandled action type: ${action.type}`);
	}
}

function WishlistProvider({ children }) {
	const [wishlistProducts, dispatch] = React.useReducer(wishlistReducer, 
		JSON.parse(localStorage.getItem("WISHLIST_DATA")),
	);

	const value = { wishlistProducts, wishlistDispatch:dispatch };
	return (
		<WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>
	);
}

function useWishlistContext() {
	const context = React.useContext(WishlistContext);
	if (context === undefined) {
		throw new Error("useCount must be used within a CountProvider");
	}
	return context;
}

const addProductToWishlist = async (dispatch, data) => {
	try {
        // console.log("wishlist data", data)
		localStorage.setItem("WISHLIST_DATA", JSON.stringify(data));
		await dispatch({ type: "ADDED_WISHLIST_PRODUCT", data });
	} catch (e) {
		console.log(e);
	}
};


export {
	addProductToWishlist,
    WishlistProvider,
    useWishlistContext
};
